import {ActionType, createAction} from 'typesafe-actions';
import {SearchFeature} from '../../../../interfaces/SearchFeature';

export const viewerApiServiceSearchOptionsCompleted = createAction(
    'VIEWER_API_SERVICE_SEARCH_OPTIONS_COMPLETED',
    (action) => (searchFeatures: SearchFeature[]) => action({searchFeatures}),
);

export const viewerApiServiceSearchOptionsFailedWithUnexpectedError = createAction(
    'VIEWER_API_SERVICE_SEARCH_OPTIONS_FAILED_WITH_UNEXPECTED_ERROR',
    (action) => () => action({}),
);

export type ViewerApiServiceSearchOptions =
    | ActionType<typeof viewerApiServiceSearchOptionsCompleted>
    | ActionType<typeof viewerApiServiceSearchOptionsFailedWithUnexpectedError>;
